import convertPhoneNumber from './convertPhoneNumber';

const MIN_PREFIX_LENGTH = 3;
const MAX_PREFIX_LENGTH = 5;
const NATIONAL_NUMBER_LENGTH = 10;
export const ADDRESS_PHONE_MAIN_MAX_LENGTH = 9;

export function getAddressPhoneMainMaxLength() {
  return ADDRESS_PHONE_MAIN_MAX_LENGTH;
}

export function getAddressPhoneNationalDigitsCount(prefix, main) {
  const prefixDigits = String(prefix ?? '').replace(/\D/g, '');
  const mainDigits = String(main ?? '').replace(/\D/g, '');
  return prefixDigits.length + mainDigits.length;
}

function parsePrefixedPhoneString(value) {
  if (!value || !String(value).includes('_')) return null;

  const parts = String(value).split('_');
  if (parts.length < 3) return null;

  const [, prefix = '', main = ''] = parts;
  return {
    prefix: prefix.replace(/\D/g, ''),
    main: main.replace(/\D/g, ''),
  };
}

export function parseAddressPhoneFromServer({ phone, phone_prefixed: phonePrefixed }) {
  const fromPhonePrefixed = parsePrefixedPhoneString(phonePrefixed);
  if (fromPhonePrefixed) return fromPhonePrefixed;

  const fromPhone = parsePrefixedPhoneString(phone);
  if (fromPhone) return fromPhone;

  const digits = String(phone || '').replace(/\D/g, '').replace(/^[78]/, '');
  if (digits.length === NATIONAL_NUMBER_LENGTH) {
    return {
      prefix: digits.slice(0, MIN_PREFIX_LENGTH),
      main: digits.slice(MIN_PREFIX_LENGTH),
    };
  }

  return { prefix: '', main: '' };
}

export function formatAddressPhoneForDisplay({ phone, phone_prefixed: phonePrefixed }) {
  const parsed = parsePrefixedPhoneString(phonePrefixed);
  if (parsed && parsed.prefix.length !== MIN_PREFIX_LENGTH) {
    return `+7 ${parsed.prefix} ${parsed.main}`;
  }
  return convertPhoneNumber(phone);
}

export function formatAddressPhoneForSave(prefix, main) {
  const prefixDigits = String(prefix ?? '').replace(/\D/g, '');
  const mainDigits = String(main ?? '').replace(/\D/g, '');
  return `7_${prefixDigits}_${mainDigits}`;
}

export function getAddressPhoneError(prefix, main) {
  const nationalDigitsCount = getAddressPhoneNationalDigitsCount(prefix, main);
  if (nationalDigitsCount < NATIONAL_NUMBER_LENGTH) {
    return 'Номер должен содержать минимум 10 цифр';
  }
  return '';
}

export function isAddressPhoneValid(prefix, main) {
  return !getAddressPhoneError(prefix, main);
}
